import {createLogger} from 'shared/services/logger';

const logger = createLogger('slide-tray:us-extension:DstWrapper');

export function DstWrapper (uScope, vil) {
  this.canStart = () => {
    const {displayDST} = vil.getInstance().getConfiguration() || {};
    if (!displayDST) {
      logger.warn('DST wrapper cannot start; disabled by vil settings');
    }

    return displayDST || false;
  };

  this.getInstance = () => {
    return $.getDstInstance();
  };
}



// WEBPACK FOOTER //
// ./src/slide-tray/uScope-extensions/dst-wrapper/DstWrapper.js